// extracted by mini-css-extract-plugin
export var CapitalizeLabel = "index-module--CapitalizeLabel--19261";
export var PriceLine = "index-module--PriceLine--631ef";
export var ReceiptPrice = "index-module--ReceiptPrice--0f6be";
export var SubTotal = "index-module--SubTotal--473f7";